<script lang="ts">
import dayjs from 'dayjs';
import { getStatusColor, getStatusLabel } from 'ui/components/tuition/statusFunctions';
import type { FaberPolicyStatus } from 'ui/components/tuition/enums';
import { sendErrorReport } from 'ui/components/bugsnag/index.vue';

export interface Policy {
  policyNumber: string;
  startDate: string;
  endDate: string;
  status: FaberPolicyStatus;
}
</script>
<script setup lang="ts">
defineProps<{ policy: Policy }>();
</script>
<template>
  <div
    class="text-xs flex gap-2"
    :data-cy="`tuition-policy-select-option-${policy.policyNumber}`"
  >
    <div class="text-left">
      <div class="font-semibold">
        {{ policy.policyNumber }}
      </div>
      <div class="flex gap-1">
        <div>
          {{ dayjs(policy.startDate).format('MM/DD/YYYY') }}
        </div>
        -
        <div>
          {{ dayjs(policy.endDate).format('MM/DD/YYYY') }}
        </div>
      </div>
      <div class="flex gap-1">
        <div>
          <UiChip
            :color="getStatusColor(policy.status, policy.startDate, () => sendErrorReport('Tuition Policy Summary', 'Invalid status', policy))"
            size="sm"
          />
        </div>
        <span class="text-xs capitalize">
          {{ getStatusLabel(policy.status, policy.startDate, () => sendErrorReport('Tuition Policy Summary', 'Invalid status', policy)) }}
        </span>
      </div>
    </div>
  </div>
</template>
